/**
 * Shared formatting utilities used across the dashboard.
 */

/**
 * Format a crore value with Indian number grouping.
 * e.g. 1473.5 → "₹1,473.5 Cr"
 */
export const fmtCr = (v) => {
  if (v === null || v === undefined) return '–';
  const n = Number(v);
  if (isNaN(n)) return '–';
  return `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(n)} Cr`;
};

/**
 * Format a crore value WITHOUT rupee symbol (for use in heatmaps where header shows ₹).
 * e.g. 1473.5 → "1,473.5 Cr"
 */
export const fmtCrNoSymbol = (v) => {
  if (v === null || v === undefined) return '–';
  const n = Number(v);
  if (isNaN(n)) return '–';
  return `${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(n)} Cr`;
};

/**
 * Format a date as DD/MM/YYYY.
 * Accepts ISO strings, Date objects, or YYYY-MM-DD.
 */
export const fmtDate = (d) => {
  if (!d) return '–';
  try {
    // Handle YYYY-MM-DD without timezone shift
    if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
      const [yyyy, mm, dd] = d.split('-');
      return `${dd}/${mm}/${yyyy}`;
    }
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return String(d);
    const dd = String(dt.getDate()).padStart(2, '0');
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${dt.getFullYear()}`;
  } catch {
    return String(d);
  }
};

/**
 * Format an integer with Indian comma grouping.
 * e.g. 150147 → "1,50,147"
 */
export const fmtNum = (n) => {
  if (n === null || n === undefined) return '–';
  return new Intl.NumberFormat('en-IN').format(Number(n));
};

/**
 * Format outreach numbers with K (thousands) and L (lakhs), two decimal places.
 * e.g. 2057 → "2.06K", 212884 → "2.13L", 500 → "500"
 */
export const fmtOutreach = (n) => {
  if (n === null || n === undefined) return '0';
  const v = Number(n);
  if (isNaN(v)) return '0';
  if (v >= 100000) return `${(v / 100000).toFixed(2)}L`;
  if (v >= 1000) return `${(v / 1000).toFixed(2)}K`;
  return v.toLocaleString('en-IN');
};

/** Display-only theme name mapping (does not affect data/filtering). */
const THEME_DISPLAY_MAP = { "Building Institutions": "Institutions" };
export const displayTheme = (theme) => THEME_DISPLAY_MAP[theme] || theme;
